import React from 'react';
import { brandAssets } from '../utils/mockData';

export const MascotSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#59642C] mb-6">
              Meet BBCDi
            </h2>
            <div className="w-24 h-1 bg-[#FE9E1C] mx-auto mb-6"></div>
            <p className="text-xl text-gray-600">
              Your friendly guide to discovering good food during the workday
            </p>
          </div>

          {/* Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Mascot Image */}
            <div className="order-2 lg:order-1 flex justify-center">
              <div className="relative max-w-sm mx-auto">
                <div className="absolute inset-0 bg-[#FE9E1C]/10 rounded-full blur-3xl"></div>
                <img
                  src={brandAssets.mascot}
                  alt="BBCDi - Balanced Bites Cafe Mascot"
                  className="relative w-full h-auto max-w-xs sm:max-w-sm md:max-w-md animate-float"
                />
              </div>
            </div>

            {/* Mascot Description */}
            <div className="order-1 lg:order-2 space-y-6">
              <div className="bg-gradient-to-br from-[#EBEBD3]/40 to-white p-8 rounded-3xl shadow-lg border border-[#EBEBD3]">
                <h3 className="text-2xl font-bold text-[#59642C] mb-4">
                  Your Friendly Food Companion
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  BBCDi is more than just our mascot—she's your friendly sister who genuinely cares about what you eat during your busy workday.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed">
                  With a warm smile and expert knowledge of good food, BBCDi helps you discover delicious, balanced meals that keep you energized and satisfied.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-[#59642C] p-6 rounded-2xl text-white">
                  <h4 className="font-bold text-lg mb-2">Warm</h4>
                  <p className="text-white/90 text-sm">Like a friendly sister who always knows what you need</p>
                </div>
                <div className="bg-[#FE9E1C] p-6 rounded-2xl text-white">
                  <h4 className="font-bold text-lg mb-2">Playful</h4>
                  <p className="text-white/90 text-sm">Making healthy eating fun and approachable</p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-[#961B1F] to-[#961B1F]/90 p-8 rounded-3xl text-white shadow-lg">
                <p className="text-2xl font-bold italic text-center">
                  "Because you deserve food that makes you feel good!"
                </p>
                <p className="text-center mt-2 text-white/80">— BBCDi</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
